import { Link } from "@remix-run/react";

import { useBooking } from "~/context/BookingContext";
import { AI_TAGS } from "~/data/tech";
import { useLocalizedPath } from "~/helpers/navigationHelper";
import common from "~/i18n/common";
import pages from "~/i18n/pages";
import { useT } from "~/i18n/useT";

import "./AiSpotlight.scss";

export default function AiSpotlight() {
  const t = useT(pages).home.aiSpotlight;
  const c = useT(common);
  const localize = useLocalizedPath();
  const booking = useBooking();

  return (
    <section className="ss-section ss-container">
      <div className="ss-panel ss-ai">
        <div
          className="ss-glow ss-glow--blue ss-ai__glow-a"
          aria-hidden="true"
        />
        <div
          className="ss-glow ss-glow--orange ss-ai__glow-b"
          aria-hidden="true"
        />

        <div className="ss-ai__copy">
          <p className="ss-pill ss-ai__pill">
            <span className="ss-pill__dot" aria-hidden="true" />
            {t.badge}
          </p>

          <h2 className="ss-ai__title">
            {t.titlePre} <span className="ss-ai__accent">{t.titleAi}</span>{" "}
            {t.titlePost}
          </h2>

          <p className="ss-ai__body">{t.body}</p>

          <ul className="ss-ai__tags">
            {AI_TAGS.map((tag) => (
              <li key={tag} className="ss-ai__tag">
                {tag}
              </li>
            ))}
          </ul>

          <div className="ss-ai__actions">
            <Link
              to={localize("/course/ai")}
              className="ss-btn ss-btn--primary"
            >
              {t.exploreCta}
            </Link>
            <button
              type="button"
              className="ss-btn ss-btn--ghost"
              onClick={() => booking.open("ai")}
            >
              {c.nav.bookCall}
            </button>
          </div>
        </div>

        <div className="ss-ai__media">
          <div className="ss-code" aria-hidden="true">
            <div className="ss-code__bar">
              <span
                className="ss-code__dot"
                style={{ background: "#FF5F57" }}
              />
              <span
                className="ss-code__dot"
                style={{ background: "#FEBC2E" }}
              />
              <span
                className="ss-code__dot"
                style={{ background: "#28C840" }}
              />
            </div>
            <div className="ss-code__body">
              <div>
                <span className="ss-code__kw">from</span>{" "}
                <span className="ss-code__var">skillsynergy</span>{" "}
                <span className="ss-code__kw">import</span>{" "}
                <span className="ss-code__str">Model</span>
              </div>
              <div className="ss-code__dim"># train on your own data</div>
              <div>
                <span className="ss-code__var">agent</span>{" "}
                <span className="ss-code__dim">=</span>{" "}
                <span className="ss-code__fn">Model</span>(
                <span className="ss-code__str">&quot;llm&quot;</span>)
              </div>
              <div>
                <span className="ss-code__var">agent</span>.
                <span className="ss-code__fn">learn</span>(
                <span className="ss-code__str">&quot;real projects&quot;</span>)
              </div>
              <div>
                <span className="ss-code__kw">print</span>(agent.
                <span className="ss-code__fn">deploy</span>())
              </div>
              <div className="ss-code__str">
                → career: ready
                <span className="ss-caret">_</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
